import { render, staticRenderFns } from "./TopUp.vue?vue&type=template&id=1e79b7b8&scoped=true"
import script from "./TopUp.vue?vue&type=script&lang=js"
export * from "./TopUp.vue?vue&type=script&lang=js"
import style0 from "./TopUp.vue?vue&type=style&index=0&id=1e79b7b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e79b7b8",
  null
  
)

export default component.exports